<template>
    <div class="products" :id="contentId">
        <div v-if="products === null && way_products === null || products.length === 0 && way_products.length === 0"><h6>Товары не найдены</h6></div>
        <div class="filters" v-if="filters.length > 1">
            <h6 class="w-100">Фильтр</h6>
            <div class="form-group" v-for="(filter, index) in filters">
                <input type="checkbox" :id="index + contentId" :value="filter" v-model="checkedFilter">
                <label :for="index + contentId">{{filter}}</label>
            </div>
        </div>

        <table v-if="products != null && products.length > 0 || way_products != null && way_products.length > 0" class="table table-hover">
            <thead class="thead">
            <tr>
                <td></td>
                <td @click="sort('vendor_code')">Код</td>
                <td @click="sort('name')">Наименование</td>
                <td @click="sort('remain')">Остаток</td>
                <td @click="sort('price_dealer')" class="text-center">Цена тг</td>
                <td class="text-center">Заказ (колич.)</td>
                <td class="text-center">Итог</td>
            </tr>
            </thead>

            <tbody class="tbody">
                <product-tr
                    v-for="product in checkFilter"
                    :product = "product"
                    :key="product.id"
                    :waitingIcon = true
                ></product-tr>

                <way-product-tr
                    v-for="way_product in checkWayFilter"
                    :way_product = "way_product"
                    :key="way_product.id"
                    :waitingIcon = true
                ></way-product-tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import ProductTr from "./Product";
    import WayProductTr from "./WayProduct";

    import {mapActions, mapGetters} from 'vuex'

    export default {
        props: ['contentShow', 'contentId', 'loadingS'],
        data (){
            return{
                products: [],
                way_products: [],
                loading: this.loadingS,
                orderBy: 'asc',
                sortBy: 'name',
                filters: [],
                checkedFilter: [],
            }
        },

        computed: {
            axiosParams() {
                const params = new URLSearchParams();
                params.append('category_id', this.contentId);
                return params;
            },

            checkFilter: function() {
                let _this = this;
                if(_this.checkedFilter.length === 0) {
                    return _this.products;
                } else {
                    return _this.products.filter(function(p) {
                        return _this.checkedFilter.includes(p.filter)
                    });
                }
            },

            checkWayFilter: function() {
                let _this = this;
                if(_this.checkedFilter.length === 0) {
                    return _this.way_products;
                } else {
                    return _this.way_products.filter(function(p) {
                        return _this.checkedFilter.includes(p.filter)
                    });
                }
            }
        },

        methods:{

            ...mapActions({
                getProductsWithBasketAction: 'pushProductsWithBasket',
            }),

            contentCheck: function () {
                if (this.contentShow === true) {
                    if (this.products && this.products.length <= 0){
                        this.getProducts();
                    }else{
                        $("#"+this.contentId).slideDown();
                    }

                } else {
                    $("#"+this.contentId).slideUp();
                }
            },

            getProducts: function () {
                this.loading = true;
                this.$emit('changeLoading', this.loading);
                this.axios
                    .get(this.axios.defaults.baseURL + 'products',{
                        params: this.axiosParams
                    })
                    .then(response => {
                        response.data.products.forEach(product => product.filter ? this.filters.push(product.filter) : '');
                        response.data.way_products.forEach(product => product.filter ? this.filters.push(product.filter) : '')
                        this.filters = this.filters.filter((item, i, ar) => ar.indexOf(item) === i);

                        this.way_products = response.data.way_products;

                        this.getProductsWithBasketAction({ products: response.data.products }).then(response => {
                            this.products = response
                        })
                        setTimeout(() => { $("#"+this.contentId).slideDown() }, 350)
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true;
                    })
                    .finally(() => {
                        this.loading = false;
                        this.$emit('changeLoading', this.loading );
                    });
            },

            sort:function(sort) {
                if (this.sortBy !== sort){
                    this.orderBy = 'asc';
                }

                this.products = _.orderBy(this.products, sort, this.orderBy)


                if (this.orderBy === 'asc'){
                    this.orderBy = 'desc'
                }else{
                    this.orderBy = 'asc'
                }

                this.sortBy = sort;

                //console.log(this.orderBy)
            },

        },

        watch: {
            contentShow: function () {
               this.contentCheck()
            },
        },

        components: {
            ProductTr, WayProductTr
        }
    }
</script>

<style lang="scss">
    .products{
        padding: 15px;
    }

    .filters{
        display: flex;
        flex-wrap: wrap;
        .form-group{
            margin-right: 25px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/ProductList.vue